import { TypeListitem } from './typelistitem';

export class LoadDetailPojo {
    public lstdepartment: Array<TypeListitem> = new Array<TypeListitem>();
    public lsteducation: Array<TypeListitem>  = new Array<TypeListitem>();
    public lsttechnical: Array<TypeListitem>  = new Array<TypeListitem>();
    public lstdatabase: Array<TypeListitem>  = new Array<TypeListitem>();
    public lstpackage: Array<TypeListitem>  = new Array<TypeListitem>();
    public lstlanguage: Array<TypeListitem>  = new Array<TypeListitem>();
    public hashData: string = "";
}
